import {HOST, registerModel} from '@/utils/base';
const viewport = {
    content: 'width=device-width, initial-scale=1.0, user-scalable=no',
};

export default [
    // 招投标项目管理
    {
        path: HOST + 'bidding',
        component: () => import('@/layouts/BasicLayout'),
        beforeEnter: (to, from, next) => {
            next();
        },
        children: [
            {
                // 项目投标管理
                path: 'invitbid/list',
                component: () => import('@/routes/bidding/invitbid/list'),
            },
            {
                // 项目投标新增申请
                path: 'invitbid/add',
                component: () => import('@/routes/bidding/invitbid/add'),
            },
            {
                // 项目投标编辑
                path: 'invitbid/edit',
                component: () => import('@/routes/bidding/invitbid/add'),
            },
            {
                // 项目投标详情
                path: 'invitbid/info',
                component: () => import('@/routes/bidding/invitbid/info'),
            },
        ],
    },
    // 中标管理审批
    {
        path: HOST + 'bidding',
        component: () => import('@/layouts/BasicLayout'),
        beforeEnter: (to, from, next) => {
            next();
        },
        children: [
            {
                // 中标台账管理列表
                path: 'winbid/list',
                component: () => import('@/routes/bidding/winbid/list'),
            },
            {
                // 中标管理列表
                path: 'winbid/project_list',
                component: () => import('@/routes/bidding/winbid/project_list'),
            },
            {
                // 中标录入
                path: 'winbid/add',
                component: () => import('@/routes/bidding/winbid/add'),
            },
            {
                // 中标编辑
                path: 'winbid/edit',
                component: () => import('@/routes/bidding/winbid/edit'),
            },
            {
                // 中标详情
                path: 'winbid/info',
                component: () => import('@/routes/bidding/winbid/info'),
            },
        ],
    },
    // 中标合同管理审批
    {
        path: HOST + 'bidding',
        component: () => import('@/layouts/BasicLayout'),
        beforeEnter: (to, from, next) => {
            next();
        },
        children: [
            {
                // 中标合同管理列表
                path: 'contract/list',
                component: () => import('@/routes/bidding/contract/list'),
            },
            {
                // 中标合同管理列表
                path: 'contract/win_list',
                component: () => import('@/routes/bidding/contract/win_list'),
            },
            {
                // 中标合同录入
                path: 'contract/add',
                component: () => import('@/routes/bidding/contract/add'),
            },
            {
                // 中标合同编辑
                path: 'contract/edit',
                component: () => import('@/routes/bidding/contract/add'),
            },
            {
                // 中标合同详情
                path: 'contract/info',
                component: () => import('@/routes/bidding/contract/info'),
            },
            {
                // 中标合同维护列表
                path: 'contract/attach_list',
                component: () => import('@/routes/bidding/contract/attach_list'),
            },
            {
                // 中标合同维护详情
                path: 'contract/attach_info',
                component: () => import('@/routes/bidding/contract/attach_info'),
            },
            {
                // 中标合同新增补充协议
                path: 'contract/attach_add',
                component: () => import('@/routes/bidding/contract/attach_add'),
            },
            {
                // 中标合同详情归档
                path: 'contract/attach',
                component: () => import('@/routes/bidding/contract/attach'),
            },
        ],
    },
    // 中标项目立项管理
    {
        path: HOST + 'bidding',
        component: () => import('@/layouts/BasicLayout'),
        beforeEnter: (to, from, next) => {
            next();
        },
        children: [
            {
                // 项目立项合同列表
                path: 'project/contract_list',
                component: () => import('@/routes/bidding/project/contract_list'),
            },
            {
                // 新增合同立项
                path: 'project/add',
                component: () => import('@/routes/bidding/project/add'),
            },
            {
                // 项目立项台账
                path: 'project/list',
                component: () => import('@/routes/bidding/project/list'),
            },
            {
                // 项目立项编辑
                path: 'project/edit',
                component: () => import('@/routes/bidding/project/edit'),
            },
            {
                // 项目立项台账变更
                path: 'project/list_update',
                component: () => import('@/routes/bidding/project/list_update'),
            },
            {
                // 项目立项变更
                path: 'project/update',
                component: () => import('@/routes/bidding/project/update'),
            },
            {
                // 项目立项详细
                path: 'project/info',
                component: () => import('@/routes/bidding/project/info'),
            },
        ],
    },
    // 项目计划管理
    {
        path: HOST + 'bidding',
        component: () => import('@/layouts/BasicLayout'),
        beforeEnter: (to, from, next) => {
            next();
        },
        children: [
            {
                // 大计划台账
                path: 'schedule/big_list',
                component: () => import('@/routes/bidding/schedule/big_list'),
            },
            {
                // 小计划台账
                path: 'schedule/small_list',
                component: () => import('@/routes/bidding/schedule/small_list'),
            },
            {
                // 新增大计划
                path: 'schedule/big_add',
                component: () => import('@/routes/bidding/schedule/big_add'),
            },
            {
                // 编辑大计划
                path: 'schedule/big_edit',
                component: () => import('@/routes/bidding/schedule/big_add'),
            },
            {
                // 详细大计划
                path: 'schedule/big_info',
                component: () => import('@/routes/bidding/schedule/big_info'),
            },
            {
                // 新增小计划
                path: 'schedule/small_add',
                component: () => import('@/routes/bidding/schedule/small_add'),
            },
            {
                // 编辑小计划
                path: 'schedule/small_edit',
                component: () => import('@/routes/bidding/schedule/small_add'),
            },
            {
                // 详细小计划
                path: 'schedule/small_info',
                component: () => import('@/routes/bidding/schedule/small_info'),
            },
        ],
    },
];



// WEBPACK FOOTER //
// ./src/common/bidding_router.js